<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="60%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="140px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row>
            <el-col :span="10">
              <el-form-item label="价格表名称" prop="PriceName">
                <el-input
                  v-model="form.PriceName"
                  placeholder="请输入价格表名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="价格" prop="Price">
                <el-input-number
                  v-model="form.Price"
                  :precision="2"
                  :step="0.1"
                  :min="0"
                  placeholder="请输入价格"
                  style="width: 100%; text-align-last: left"
                  controls-position="right"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="描述" prop="Remark">
                <el-input
                  v-model="form.Remark"
                  placeholder=""
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="!disabled"
          >保存</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      loading: false,

      RoleList: [],
      tD_InStorDetails: [],
      form: {
        PriceName: '',
        IsLadderPrice: null,
        Price: '',
        Remark: '',

        list: [],
      },
      rules: {
        PriceName: [
          { required: true, message: '请输入价格表名称', trigger: 'blur' },
        ],
        Price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 0) {
                callback(new Error('价格不能为负数'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      drawer: false,
      disabled: false,
      row: {},
    }
  },
  props: {},
  components: {},
  methods: {
    deteleList(row) {
      this.$set(row, 'isDetele', true)
    },
    PriceChange(num, row, key) {
      if (Number(num) < 0) {
        this.$notify.error('不能为负数')
        this.$set(row, key, 0)
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/Base/Base_OilPrice/SaveData', {
            ...this.form,
          })
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.disabled = disabled
      // this.getRoleList();
      this.row = row
      this.form = {
        PriceName: '',
        IsLadderPrice: null,
        Price: '',
        Remark: '',
      }

      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base/Base_OilPrice/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
